<div class="confirm-edit-rule evir-font-default">
  <div mat-dialog-content>
    <p>{{ "edit rule confirmation" | i18next: { count: data } }}</p>
  </div>
  <div mat-dialog-actions align="center">
    <app-action-button cdkFocusInitial title="cancel" (buttonClicked)="dialogRef.close()"></app-action-button>
    <app-action-button title="ok" (buttonClicked)="confirmEdit()"></app-action-button>

  </div>

</div>
